// extracted by mini-css-extract-plugin
export default {"container":"ProfileCard_container__OKqYk","profilePhoto":"ProfileCard_profilePhoto__YRtyc","profileStats":"ProfileCard_profileStats__8ICdv"};